const routes = [
  {
    path: '/cadastro/frotas/oficina',
    name: 'workshop',
    component: () => import('@/views/cadastros/oficina/Oficina.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Oficinas' }],
    },
  },
  {
    path: '/cadastro/frotas/oficina/novo',
    name: 'workshopNew',
    component: () => import('@/views/cadastros/oficina/OficinaNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Oficinas' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/frotas/oficina/:id/editar',
    name: 'workshopUpdate',
    component: () => import('@/views/cadastros/oficina/OficinaNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Oficinas' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/frotas/posto',
    name: 'gasStation',
    component: () => import('@/views/cadastros/posto/Posto.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Postos de Gasolina' }],
    },
  },
  {
    path: '/cadastro/frotas/posto/novo',
    name: 'gasStationNew',
    component: () => import('@/views/cadastros/posto/PostoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Postos de Gasolina' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/frotas/posto/:id/editar',
    name: 'gasStationUpdate',
    component: () => import('@/views/cadastros/posto/PostoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Postos de Gasolina' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-veiculo',
    name: 'vehicleType',
    component: () => import('@/views/cadastros/tipoVeiculo/TipoVeiculo.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Veículo' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-veiculo/novo',
    name: 'vehicleTypeNew',
    component: () => import('@/views/cadastros/tipoVeiculo/TipoVeiculoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Veículo' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-veiculo/:id/editar',
    name: 'vehicleTypeUpdate',
    component: () => import('@/views/cadastros/tipoVeiculo/TipoVeiculoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Veículo' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-uso-veiculo',
    name: 'vehicleUseType',
    component: () => import('@/views/cadastros/tipoUsoVeiculo/TipoUsoVeiculo.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Uso do Veículo' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-uso-veiculo/novo',
    name: 'vehicleUseTypeNew',
    component: () => import('@/views/cadastros/tipoUsoVeiculo/TipoUsoVeiculoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Uso do Veículo' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-uso-veiculo/:id/editar',
    name: 'vehicleUseTypeUpdate',
    component: () => import('@/views/cadastros/tipoUsoVeiculo/TipoUsoVeiculoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Uso do Veículo' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/frotas/servico-manutencao',
    name: 'serviceMaintenance',
    component: () => import('@/views/cadastros/servicoManutencao/ServicoManutencao.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Serviços de Manutenção' }],
    },
  },
  {
    path: '/cadastro/frotas/servico-manutencao/novo',
    name: 'serviceMaintenanceNew',
    component: () => import('@/views/cadastros/servicoManutencao/ServicoManutencaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Serviços de Manutenção' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/frotas/servico-manutencao/:id/editar',
    name: 'serviceMaintenanceUpdate',
    component: () => import('@/views/cadastros/servicoManutencao/ServicoManutencaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Serviços de Manutenção' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-encargo',
    name: 'chargeType',
    component: () => import('@/views/cadastros/tipoEncargo/TipoEncargo.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Encargo' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-encargo/novo',
    name: 'chargeTypeNew',
    component: () => import('@/views/cadastros/tipoEncargo/TipoEncargoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Encargo' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/frotas/tipo-encargo/:id/editar',
    name: 'chargeTypeUpdate',
    component: () => import('@/views/cadastros/tipoEncargo/TipoEncargoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipo de Encargo' }, { title: 'Editar' }],
    },
  },
  {
    path: '/cadastro/frotas/tipos-manutencao',
    name: 'maintenanceType',
    component: () => import('@/views/cadastros/maintenanceType/TipoManutencao.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipos de Manutenção' }],
    },
  },
  {
    path: '/cadastro/frotas/tipos-manutencao/novo',
    name: 'maintenanceTypeNew',
    component: () => import('@/views/cadastros/maintenanceType/TipoManutencaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipos de Manutenção' }, { title: 'Novo' }],
    },
  },
  {
    path: '/cadastro/frotas/tipos-manutencao/:id/editar',
    name: 'maintenanceTypeUpdate',
    component: () => import('@/views/cadastros/maintenanceType/TipoManutencaoNew.vue'),
    meta: {
      breadcrumb: [{ title: 'Cadastro' }, { title: 'Frotas' }, { title: 'Tipos de Manutenção' }, { title: 'Editar' }],
    },
  },
]

export default routes
